<template>
  <div class="custom-tabs-small">
    <div class="tabs is-boxed">
      <ul>
        <li :class="{'is-active': isActiveTab(tab.id)}" v-for="(tab, index) in tabs" :key="index">
          <a href="#" :data-track="tab.track" @click.prevent="activateTab(tab.id, true)">
            <span>{{ tab.label }}</span>
          </a>
        </li>
      </ul>
    </div>

    <div v-for="(tab, index) in tabs" v-show="activeTab == tab.id" :key="index">
      <slot :name="tab.id"></slot>
    </div>
  </div>
</template>

<script>
import {misc} from '@/mixins'

export default {
  name: 'CustomTabsJs',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    group: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      activeTab: ''
    }
  },
  mixins: [misc],
  created () {
    for (let tab of this.tabs) {
      if ('active' in tab && tab.active) {
        this.activateTab(tab.id)
        break
      }
    }
  },
  methods: {
    isActiveTab (tabId) {
      if (this.activeTab === tabId) {
        return true
      }
      return false
    },
    activateTab (tabId, isDoneManual = false) {
      this.activeTab = tabId

      window.events.$emit('custom-tab-js-changed', {
        group: this.group,
        tabId: tabId,
        changedByHuman: isDoneManual
      })
    }
  }
}
</script>

<style scoped>
.custom-tabs-small li {
  width: 164px;
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomTabsJs.vue